"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.System = void 0;
var sources_1 = require("../../shared/sources");
var shared_1 = require("../../shared");
var System = /** @class */ (function (_super) {
    __extends(System, _super);
    function System(setupConfigParams) {
        var settings = [];
        // TODO: ES Modules
        if (document.currentScript) {
            var attrsParams = getParametersFromAttributes(document.currentScript);
            var urlParams = getParametersFromSrc(document.currentScript);
            var projectName = (0, shared_1.mkSetting)({
                key: shared_1.SYSTEM_KEYS.projectName,
                value: (setupConfigParams === null || setupConfigParams === void 0 ? void 0 : setupConfigParams.settingsKey) ||
                    attrsParams.projectName ||
                    (urlParams === null || urlParams === void 0 ? void 0 : urlParams.projectName) ||
                    (setupConfigParams === null || setupConfigParams === void 0 ? void 0 : setupConfigParams.projectName),
                priority: 10000,
            });
            var requestId = (0, shared_1.mkSetting)({
                key: shared_1.SYSTEM_KEYS.requestId,
                value: attrsParams.requestId || (urlParams === null || urlParams === void 0 ? void 0 : urlParams.requestId) || (setupConfigParams === null || setupConfigParams === void 0 ? void 0 : setupConfigParams.requestId),
                priority: 10000,
            });
            var versionCommit = (0, shared_1.mkSetting)({
                key: shared_1.SYSTEM_KEYS.versionCommit,
                value: attrsParams.versionCommit || (urlParams === null || urlParams === void 0 ? void 0 : urlParams.versionCommit),
                priority: 10000,
            });
            if (projectName === null || projectName === void 0 ? void 0 : projectName.value) {
                settings.push(projectName);
            }
            if (requestId === null || requestId === void 0 ? void 0 : requestId.value) {
                settings.push(requestId);
            }
            if (versionCommit === null || versionCommit === void 0 ? void 0 : versionCommit.value) {
                settings.push(versionCommit);
            }
        }
        return _super.call(this, settings) || this;
    }
    return System;
}(sources_1.SortedSource));
exports.System = System;
function getParametersFromAttributes(scriptEl) {
    var projectName = scriptEl.dataset[shared_1.SYSTEM_KEYS_ATTR_MAP.projectName];
    var requestId = scriptEl.dataset[shared_1.SYSTEM_KEYS_ATTR_MAP.requestId];
    var versionCommit = scriptEl.dataset[shared_1.SYSTEM_KEYS_ATTR_MAP.versionCommit];
    return { projectName: projectName, requestId: requestId, versionCommit: versionCommit };
}
function getParametersFromSrc(scriptEl) {
    var src = scriptEl.getAttribute('src');
    if (!src) {
        return null;
    }
    var searchParams = new URL(src, window.location.origin).searchParams;
    var projectName = searchParams.get(shared_1.SYSTEM_KEYS_QUERY_MAP.projectName);
    var requestId = searchParams.get(shared_1.SYSTEM_KEYS_QUERY_MAP.requestId);
    var versionCommit = searchParams.get(shared_1.SYSTEM_KEYS_QUERY_MAP.versionCommit);
    return { projectName: projectName, requestId: requestId, versionCommit: versionCommit };
}
//# sourceMappingURL=system.js.map